var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoEditar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1557",
    "data-name": "Ret\\xE2ngulo 1557",
    width: 19,
    height: 19,
    transform: "translate(0 0)",
    fill: "#171717"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ico_editar",
    "data-name": "Ico editar",
    transform: "translate(0.442 0.442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3488",
    "data-name": "Grupo 3488",
    transform: "translate(-0.442 -0.442)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5985",
    "data-name": "Caminho 5985",
    d: "M240.615,137.288,240,140.264a.257.257,0,0,0,.3.3l2.976-.611.13-.07,6.4-6.4a.128.128,0,0,0,0-.182l-2.544-2.544a.128.128,0,0,0-.182,0l-6.4,6.4-.07.13",
    transform: "translate(-234.17 -127.398)",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5986",
    "data-name": "Caminho 5986",
    d: "M16.151,89.186h-1.1a.367.367,0,0,0-.367.367v5.139H1.835V81.844H6.057a.367.367,0,0,0,.367-.367v-1.1a.367.367,0,0,0-.367-.367H.918A.918.918,0,0,0,0,80.927V95.609a.918.918,0,0,0,.918.918H15.6a.918.918,0,0,0,.918-.918V89.553a.367.367,0,0,0-.367-.367",
    transform: "translate(0.323 -77.85)",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5987",
    "data-name": "Caminho 5987",
    d: "M616.31,2.005,614.493.188a.642.642,0,0,0-.908,0L612.243,1.53a.183.183,0,0,0,0,.26l2.466,2.466a.184.184,0,0,0,.26,0l1.341-1.341a.642.642,0,0,0,0-.909",
    transform: "translate(-597.821 0.323)",
    fill: "#171717"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEditar);
export default __webpack_public_path__ + "static/media/IcoEditar.cda12d86322d9d2449c3703a9d3b6b9c.svg";
export { ForwardRef as ReactComponent };